import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as: Tag = "div" }) => {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easing }}
    >
      {children}
    </MotionTag>
  );
};

export const RevealLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={`${line}-${i}`} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, delay: delay + i * 0.13, ease: easing }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
